module.exports = __webpack_public_path__ + "img/user.4ebd5b1b.svg";